export default __webpack_public_path__ + "static/media/Snd_ClowerT.9667131c.mp3";